// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, number, object, oneOfType, string } from 'prop-types'
import { DataHeadingWrapper } from './styles'
import SortIcon from './SortIcon'

const DataHeading = props => {
  const {
    columnData,
    handleSort,
    stickyTop,
    tableSort,
  } = props

  const {
    field,
    sortable = true,
    title,
    width,
  } = columnData

  if (columnData.headerCell) {
    return (
      <columnData.headerCell
        columnData={columnData}
        handleSort={handleSort}
        stickyTop={stickyTop}
        tableSort={tableSort} />
    )
  }

  return (
    <DataHeadingWrapper
      stickyTop={stickyTop}
      width={width}>
      <div
        className={sortable ? 'cursor-pointer' : ''}
        onClick={() => sortable && handleSort(field)}
        title={title}>
        <span>
          {title}
        </span>
        {
          sortable &&
          <SortIcon
            field={field}
            tableSort={tableSort} />
        }
      </div>
    </DataHeadingWrapper>
  )
}

DataHeading.propTypes = {
  columnData: object.isRequired,
  handleSort: func,
  sortable: bool,
  stickyTop: oneOfType([
    string,
    number,
  ]),
  tableSort: object,
}

export default DataHeading
